export function dispatchConversationEvent() {
  const conversationEvent = new CustomEvent('conversation');
  document.dispatchEvent(conversationEvent);
}
